/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import {JSONable} from '@irian-ro/abstract-resource';

export class ServiceProviderQualificationViewModel extends JSONable {

  uuid: string | undefined = undefined;

  name: string | undefined = undefined;

  deliveredInTimePercentage: string | undefined = undefined;

  averagePricePerKm: string | undefined = undefined;

  complaintPercentage: string | undefined = undefined;

  countries: string | undefined = undefined;

  routes: string | undefined = undefined;

  fleetSize: string | undefined = undefined;

  vehicleTypes: string | undefined = undefined;

}
